module.exports = __webpack_public_path__ + "media/elevadizo/buqueIzquierda-di-ap-517bf7ff.png";